import { useState, useEffect } from 'react';
import { useLang } from '../context/LanguageContext';
import './BreakingNewsTicker.css';

import { API_URL as API } from '../config/env.js';

export default function BreakingNewsTicker() {
  const { t, lang } = useLang();
  const [headlines, setHeadlines] = useState(t.headlines);

  useEffect(() => {
    setHeadlines(t.headlines);
    fetch(`${API}/api/breaking-news`)
      .then(r => r.json())
      .then(data => { if (data.length) setHeadlines(data.map(h => h.headline)); })
      .catch(() => {});
  }, [lang, t.headlines]);

  const items = headlines.join('   ◆   ');

  return (
    <div className="ticker-bar">
      <span className="ticker-label">{t.tickerLabel}</span>
      <div className="ticker-track">
        <div className="ticker-scroll">
          <span>{items}</span>
          <span aria-hidden="true">&nbsp;&nbsp;&nbsp;◆&nbsp;&nbsp;&nbsp;{items}</span>
        </div>
      </div>
    </div>
  );
}
